import React from 'react';
import "./intro.css";
import bg from '../../assets/headshot (2).png';
import btnImg from '../../assets/hireme.png';

const Intro = () => {
  return (
    <section id="intro">
      <div className="introContent">
        <span className="hello">Hello </span>
        <span className="introText">I'm <span className="introName">Eldin Salja,</span><br />Software Engineer</span>
        <p className="introPara">I'm based in Lincoln, Nebraska and I specialize in creating <br /> websites, and applications with hopes of expanding my skillset.</p>
        <a href="https://www.linkedin.com/in/eldinsalja/" target="_blank" rel="noopener noreferrer">
          <button className="btn">
            <img src={btnImg} alt="Hire Me" className="btnImg" />Hire Me
          </button>
        </a>
      </div>
      <img src={bg} alt="Profile" className="bg" />
    </section>
  );
}

export default Intro;